import CustomCard from '../../../../components/CustomCard';
import CustomGenericTittleIconDataChip from '../../../../components/CustomGenericTittleIconDataChip';
import {DetailsIconsOptions, IconMarkerTable} from '../../../../components/buttons/IconButtons';
import ZoneLeaflet from '../../../../components/ZoneLeaflet';
import CustomTooltip from "../../../../components/CustomTooltip";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";
import React from "react";
import {POSITION_MODEL} from "../../../../Helpers/PositionModel";
/**
 * @Email sgarcia@ibl.mx
 * @Author Susana Garcia Rodriguez
 * @JobTitle Frontend
 *
 * @component LocationCard
 * @description A card that displays a map with location data and zone information.
 *
 * @param {Object} props - Component props.
 * @param {function} props.t - Translation function for i18n.
 * @param {[number, number]} props.latlng - Latitude and longitude coordinates.
 * @param {function} props.setLatitude - Callback to update the latitude.
 * @param {function} props.setLongitude - Callback to update the longitude.
 * @param {function} props.searchLocation - Function to trigger a location search.
 * @param {string} props.mainZone - Main zone name.
 * @param {string} props.subZone - Sub-zone name.
 * @param {string} props.location - Full location description.
 * @param {string} props.containerClass - Additional CSS class for the map container.
 * @param {boolean} disabled - To disabled map
 * @param {string} props.classCard - Extra CSS classes for card.
 * @param {string} props.classNameLocation - Extra CSS classes for location text.
 * @param {string} props.title - Optional title for the card.
 * @param {L.Icon} [props.iconMarker] - Custom Leaflet icon for markers
 * @param {number} [props.mapZoom] - Map zoom level.
 * @param {'left'|'right'} [props.iconPosition] - Side of the text where the open in maps icon is rendered.
 */
const LocationCard = ({ t, latlng, setLatitude, setLongitude, searchLocation, mainZone, subZone,
                          location,classNameLocation, classNameMap, disabled=false, classCard, title=true, mapZoom, iconMarker}) => {
    const url = `https://www.google.com/maps/search/?api=1&query=${latlng?.[0]},${latlng?.[1]}`;
    return (
        <>
            <CustomCard  classCard={`card-border-8px minh-235px z-index-3 ${classCard || ''}`} classContent={'p-0'}>
                {title && (
                <div className="row my-2">
                    <div>
                        <CustomGenericTittleIconDataChip  title={title || t('location')}  Icon={IconMarkerTable} border={false} />
                    </div>
                </div>
                )}
                <div className='w-100'>
                    <ZoneLeaflet
                        latlng={latlng}
                        setLatitude={setLatitude}
                        setLongitude={setLongitude}
                        searchLocation={searchLocation}
                        classNameMap={classNameMap}
                        disabled={disabled}
                        mapZoom={mapZoom}
                        iconMarker={iconMarker}
                    />
                </div>

                <div className='my-2'>
                    { (mainZone || subZone) &&
                        <div className='d-flex align-items-center m-0 p-0'>
                            <span className='fs-14px font-color-general-950 ibl-font-w-600 ml-3'>{mainZone}</span>
                            { mainZone && subZone && <span className='mx-2'>•</span> }

                            <span className='fs-12px font-color-general-950 ibl-font-w-400'>{subZone}</span>
                        </div>
                    }


                    <CustomTooltip
                        text={location}
                        showIfTruncated={true}
                        classes={`${classNameLocation} fs-12px ibl-font-w-600 font-color-general-950 ml-2 mt-0 word-break text-ellipsis-1-row`}
                    />

                    <CustomButtonLink
                        splitName={false}
                        id="btn_lc_open_in_maps"
                        card={true}
                        onClick={()=>{
                            window.open(url, '_blank');
                        }}
                        name="open_in_maps"
                        Icon={DetailsIconsOptions}
                        iconPosition={POSITION_MODEL.RIGHT}
                    />
                </div>
            </CustomCard>
        </>
    );
};

export default LocationCard;
